import { state } from './state';
import { actions } from './actions';
import { mutations } from './mutations';
import { getters } from './getters';
import { Module } from 'vuex';
import { StoreType } from '@/types/store/store.type';
import { EventsStoreType } from '@/types/store/events-store.type';

const namespaced: boolean = true;
export const events: Module<EventsStoreType, StoreType> = {
  namespaced,
  state,
  actions,
  mutations,
  getters
};
